import { Checkbox } from '@mui/material'
import Input from '@returnmates/ui-core/src/components/Input'
import { memo } from 'react'
import { Field } from 'react-final-form'

import useStyles from '../styles'

function ReadyCloudSettings() {
  const classes = useStyles({})

  return (
    <>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Enable ReadyCloud module</p>
        <Field name="isReadyCloudEnabled">
          {({ input }) => <Checkbox checked={input.value} onChange={input.onChange} />}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>ReadyCloud url</p>
        <Field name="readyCloudUrl">
          {({ input, meta }) => (
            <Input
              placeholder="url"
              classes={{
                textField: classes.input,
                input: classes.multilineInput,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
    </>
  )
}

export default memo(ReadyCloudSettings)
